import './_image.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'img'>,
  {
    src: string
    alt?: string
    height?: string
    width?: string
    loading?: 'lazy' | 'eager'
    fit?: 'cover' | 'contain' | 'scale-down'
    inline?: boolean
    centered?: boolean
  }
>

const Image = ({
  className,
  src,
  alt = '',
  height,
  width,
  loading,
  fit,
  inline = false,
  centered = false,
  ...props
}: Props) => (
  <img
    {...props}
    className={cn(
      'Image',
      {inline, [`fit-${fit}`]: !!fit, centered, fixedHeight: !!height && !width},
      className
    )}
    src={src}
    alt={alt}
    height={height}
    width={width}
    loading={loading}
  />
)

export default Image
